import { Button, CircularProgress, Typography } from '@mui/material';
import LinearProgress, { LinearProgressProps } from '@mui/material/LinearProgress';
import {
  StyledInformationDialog,
  StyledInformationDialogContent,
  StyledInformationDialogTitle,
} from 'components/dialog/Dialog.styles.tsx';
import Box from '@mui/material/Box';
import { Cancel } from '@mui/icons-material';

export type Props = {
  isVisible: boolean;
  title: string;
  subtitle?: string;
  progress?: number;
  onCancel?: () => void;
};

export function LinearProgressWithLabel(props: LinearProgressProps & { value: number; showLabel?: boolean }) {
  return (
    <Box sx={{ display: 'flex', alignItems: 'center', width: '100%' }}>
      <Box sx={{ width: '100%', mr: props.showLabel ? 1 : 0 }}>
        <LinearProgress variant="determinate" {...props} />
      </Box>
      {props.showLabel && (
        <Box sx={{ minWidth: 35 }}>
          <Typography variant="body2" sx={{ color: 'text.secondary' }}>{`${Math.round(props.value)}%`}</Typography>
        </Box>
      )}
    </Box>
  );
}

const LoadingDialog = ({ isVisible, title, progress, onCancel }: Props) => {
  return (
    <StyledInformationDialog open={isVisible}>
      <StyledInformationDialogTitle>{title}</StyledInformationDialogTitle>
      <StyledInformationDialogContent className="p-0">
        {progress !== undefined ? (
          <LinearProgressWithLabel showLabel value={progress} />
        ) : (
          <CircularProgress color="primary" size={40} />
        )}
        {onCancel && (
          <Button onClick={onCancel} color="secondary" variant="outlined" className="mt-4" startIcon={<Cancel />}>
            Cancel
          </Button>
        )}
      </StyledInformationDialogContent>
    </StyledInformationDialog>
  );
};

export default LoadingDialog;
